import React, { useCallback, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { AnimatedSlidingDiv } from './AnimatedSlidingDiv';
import { GenericButton } from './Buttons';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: theme.iconSize.large,
    marginLeft: theme.marginBase / 2,
    transition: 'transform .3s',
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
}));

interface Props {
  children: React.ReactNode;
  label: string;
  className?: string;
}

export const FoldableOpenMore = ({ children, className, label }: Props) => {
  const classes = useStyles();

  const contentRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const onToggle = useCallback(() => {
    setIsOpen((state) => !state);
  }, [setIsOpen]);

  return (
    <div className={className}>
      <GenericButton className={classes.button} onClick={onToggle}>
        {label}
        <i
          className={classNames(classes.icon, 'ri-arrow-down-s-line', {
            [classes.iconOpen]: isOpen,
          })}
        />
      </GenericButton>

      <AnimatedSlidingDiv
        isOpen={isOpen}
        maxHeight={(contentRef.current?.clientHeight || 1000) + 20}
      >
        <div ref={contentRef}>{children}</div>
      </AnimatedSlidingDiv>
    </div>
  );
};
